module.exports = __webpack_public_path__ + "img/33_10.98a8e96c.png";